import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Datenschutz = () => {
  return (
    <div data-testid="datenschutz-page" className="min-h-screen bg-[#FCF9F5]">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <Link
          to="/"
          data-testid="datenschutz-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#B56553] hover:text-[#9B5342] transition-colors mb-10"
        >
          <ArrowLeft size={15} strokeWidth={1.75} /> Zurück zur Startseite
        </Link>
        <span className="text-[11px] tracking-[0.28em] uppercase text-[#B56553]">
          Rechtliches
        </span>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl text-[#4A362E] leading-tight">
          Datenschutz
        </h1>
        <p className="mt-6 text-sm text-[#8A7A72]">
          Informationen gemäß Art. 13 DSGVO
        </p>

        <div className="mt-14 space-y-10 text-[#5C4E48] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              1. Verantwortliche Stelle
            </h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="mt-3">
              Physiotherapie Borghese
              <br />
              Giusi Borghese
              <br />
              Bruchstraße 8
              <br />
              30952 Ronnenberg-Empelde
              <br />
              Telefon: 0176 21684344
              <br />
              E-Mail: Borghesegiusi@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              2. Erhebung und Verarbeitung personenbezogener Daten
            </h2>
            <p>
              Sie können diese Website grundsätzlich besuchen, ohne
              personenbezogene Daten anzugeben. Beim Aufruf der Website werden
              durch den Browser automatisch technische Daten übermittelt (z. B.
              IP-Adresse, Datum und Uhrzeit, verwendeter Browser), die
              ausschließlich zur Sicherstellung eines störungsfreien Betriebs
              verarbeitet werden. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              3. Terminvereinbarung
            </h2>
            <p>
              Für die Terminvereinbarung nutzen wir den externen Dienst
              Doctolib. Wenn Sie über den Button „Online buchen&rdquo; zur
              Doctolib-Website weitergeleitet werden, gelten die
              Datenschutzbestimmungen von Doctolib. Weitere Informationen
              finden Sie unter{" "}
              <a
                href="https://www.doctolib.de/terms/data-protection"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B56553] hover:text-[#9B5342] underline underline-offset-4"
              >
                doctolib.de/terms/data-protection
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              4. Karten-Einbindung (Google Maps)
            </h2>
            <p>
              Zur Darstellung der Anfahrt wird auf dieser Website eine
              eingebettete Karte des Anbieters Google Ireland Ltd. verwendet.
              Beim Aufruf der Seite können Daten (z. B. IP-Adresse) an Google
              übertragen werden. Weitere Informationen finden Sie in der
              Datenschutzerklärung von Google:{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#B56553] hover:text-[#9B5342] underline underline-offset-4"
              >
                policies.google.com/privacy
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              5. Kontaktaufnahme
            </h2>
            <p>
              Wenn Sie per Telefon oder E-Mail Kontakt aufnehmen, werden Ihre
              Angaben zur Bearbeitung Ihrer Anfrage sowie für den Fall von
              Anschlussfragen gespeichert. Die Verarbeitung erfolgt auf
              Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines
              Behandlungsverhältnisses) bzw. Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an einer effizienten Beantwortung).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              6. Ihre Rechte als betroffene Person
            </h2>
            <p>
              Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO),
              Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO),
              Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit
              (Art. 20 DSGVO) sowie das Recht auf Widerspruch (Art. 21 DSGVO).
              Zudem können Sie sich bei einer Datenschutz-Aufsichtsbehörde
              beschweren (Art. 77 DSGVO).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#4A362E] mb-3">
              7. Datensicherheit
            </h2>
            <p>
              Diese Website verwendet aus Gründen der Sicherheit eine
              SSL/TLS-Verschlüsselung, um die Übertragung vertraulicher Inhalte
              zu schützen.
            </p>
          </section>

          <p className="text-xs text-[#8A7A72] pt-8 border-t border-[#E8DFD8]">
            Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
